var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 21.7501H7.25016C6.41683 21.7501 5.8335 21.0834 5.8335 20.3334V7.83344H18.1668V20.2501C18.1668 21.0834 17.5002 21.7501 16.7502 21.7501Z",
    stroke: "#EF6B6B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.33333V5.83333C19 5.25 18.5 4.75 17.9167 4.75H14.8333L14.5 3.5C14.3333 3.16667 14.0833 3 13.6667 3H10.3333C10 3 9.66667 3.16667 9.5 3.5L9.16667 4.66667H6.08333C5.5 4.66667 5 5.16667 5 5.75V7.33333C5 7.58333 5.25 7.83333 5.5 7.83333H18.5C18.8333 7.83333 19 7.58333 19 7.33333Z",
    stroke: "#EF6B6B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 10.8333V18.75",
    stroke: "#EF6B6B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.8332V18.7499",
    stroke: "#EF6B6B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 10.8332V18.7499",
    stroke: "#EF6B6B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.254f1f8b4c0d0a9dc883ac5a52315711.svg";
export { ForwardRef as ReactComponent };